import VideoWidget from "../video_widget/video-widget";
import GenericLoader from "../loaders/generic_loader";
import eventEmitter from '../_helpers/event_emitter';
//#region External imports
import imagesLoaded from "imagesloaded";
import Isotope from "isotope-layout";
import cellsByRow from "isotope-cells-by-row";
import jQueryBridget from 'jquery-bridget';
// make Isotope a jQuery plugin
jQueryBridget( 'isotope', Isotope, $ );

//#endregion

//#region Rendering
import layoutTemplate from '../../templates/stand_alone_video_widget_page/layout.hbs';
import videoInfoContainerTemplate from '../../templates/stand_alone_video_widget_page/video_info_container.hbs';
import videoPlayerOverlayTemplate from '../../templates/stand_alone_video_widget_page/video_player_overlay.hbs';
//#endregion

export default function InitStandAloneVideoWidgetPage(widgetCode, cdn) {
    return new StandAloneVideoWidgetPage(widgetCode, cdn);
}

class StandAloneVideoWidgetPage {
    _widgetCode = null;
    /** @type {VideoWidget} */
    _videoWidget = null;
    _cdn = null;
    _analytics = null;

    _loadingIndicator = null;
    _videoOpenCount = 0;

    static EVENT_URL_DATA_CHANGED = 'stand_alone_widget_page.url_data_changed';
    static EVENT_READY = 'stand_alone_widget_page.ready';

    static IDLE_TIMEOUT = 10000; 
    _timeout;
    static activityEvents = ['load', 'mousemove', 'mousedown', 'touchstart', 'click', 'scroll', 'keydown'];


    constructor(widgetCode, cdn) {
        eventEmitter.install(this);

        this._widgetCode = widgetCode;
        this._cdn = cdn;
        this._renderTarget = $('body').find(this._renderTarget);

        // this._loadingIndicator = GenericLoader();
        // this._loadingIndicator.init({
        //     loaderTitle:"Loading Story Feed",
        //     loaderDescription:""
        // });
    }

    async init() {
        
        this._videoWidget = await VideoWidget.Init(this._widgetCode, this._cdn);
        try {
            this._analytics = VMJA({
                source: 'WidgetStandAlone',
                send_events: true,
                widget_id:this._widgetCode
            });
        } catch (error) {
            console.log(error);
            // if we fail to load analytics we create a fake object to use instead to prevent the whole ship sinking. 
            this._analytics = {
                track: function(){
                    return true;
                },
                setPlayer: function(){
                    return true;
                }
            }
        }

        // Inject styles before we start rendering
        this._videoWidget.injectCSS();

        this._initRender();
        this._analytics.track({
            name: 'PageView',
            value: 1
        });

        StandAloneVideoWidgetPage.activityEvents.forEach(event => {
            document.addEventListener(event, this.resetTimer.bind(this), false);
        });
        this.resetTimer();

    }

    resetTimer() {
        clearTimeout(this._timeout);
        this._isIdle = false;
        this._timeout = setTimeout(this._handleIsIdleCallback.bind(this), StandAloneVideoWidgetPage.IDLE_TIMEOUT);
    }
    //#region Rendering

    _renderTarget = '#content';
    _videoModal = null;
    _isotopeGrid = null;
    _feedbackModal = null;
    

    // Set up the general page content, as well as any general event handlers that can be setup
    _initRender() {
        // TODO Pending design 
        if(this._videoWidget.widget_enabled == true){
            // clears the page content, and replaces it with the widgets layout
            this._renderTarget.html(layoutTemplate(this._videoWidget));


            this._isotopeGrid = this._renderTarget.find('#isotope-grid-target').isotope({
                itemSelector: '.video-item',
                layoutMode: 'fitRows'
            });

            
            this._videoModal = this._renderTarget.find('#videoPlayerModal');
            this._feedbackModal = this._renderTarget.find('#feedbackModal');
            // Create the video player, it shouldn't be disposed
            this._initPlayer();

            // setup event handlers
            this._renderTarget.on('click', '.video-modal-link', this._handleVideoItemClicked.bind(this));
            this._videoModal.on('click', '.learn-more-btn', this._handleCTAClicked.bind(this));
            this._videoModal.on('click', '.next-video', this._handleNextClicked.bind(this));
            this._videoModal.on('click', '.watch-again', this._handleWatchAgainClicked.bind(this));
            this._videoModal.on('click', '.js-copy-video-url', this._handleCopyShare.bind(this));
            this._videoModal.on('click', '.js-share-LI', this._handleLinkedInShare.bind(this));
            this._videoModal.on('click', '.js-share-FB', this._handleFacebookShare.bind(this));
            
            
            this._renderTarget.on('click', '.clearbtn', this._handleClearFiltersClicked.bind(this));
            this._renderTarget.on('change', '.tag input', this._handleFilterInputChanged.bind(this));
            this._renderTarget.on('click', '#openbtn', this._handleOpenSidebarClicked.bind(this));
            this._renderTarget.on('click', '.closebtn', this._handleCloseSidebarClicked.bind(this));
            this._renderTarget.on('click', '.show-more', this._handleShowMoreTagsClicked.bind(this));
            this._renderTarget.on('mouseenter', '.video-item-card img', this._handleMouseEnterVideoItemCard.bind(this));
            this._renderTarget.on('mouseleave', '.video-item-card img', this._handleMouseLeaveVideoItemCard.bind(this));
            this._renderTarget.on('click', '#hero-btn', this._handleHeroButtonClicked.bind(this));
            
            this._feedbackModal.on('click', '.feedback-response', this._handleFeedbackResponseClicked.bind(this));
            this._feedbackModal.on('click', 'input[name="user_description"]', this._handleFeedbackUserDescriptionClicked.bind(this));
            this._feedbackModal.on('keyup', 'input[type="text"], textarea', this._handleFeedbackTextKeyUp.bind(this));
            this._feedbackModal.on('click', '#submit-feedback', this._handleFeedbackSubmit.bind(this));
            this._feedbackModal.on('hidden.bs.modal', this._handleFeedbackModalHidden.bind(this));
            
            this.addEventListener(StandAloneVideoWidgetPage.EVENT_URL_DATA_CHANGED, this._handleHistoryState.bind(this));
            this.addEventListener(StandAloneVideoWidgetPage.EVENT_READY, this._hideLoadingIndicator.bind(this));

            this._decodeUrlForCurrentState();
            //JANK update a href in a specific case temporarily until we have a better solution for dynamic links in the widget
            if(this._widgetCode == "b5TTOC9G") {
                this._renderTarget.find('.navbar-brand').attr('href', "https://dev.videomyjob.com/");
            }
            if(this._widgetCode == "GsDHG3bE") {
                this._renderTarget.find('.navbar-brand').attr('href', "https://nih.com.au/");
            }   
        }
        else {
            //don't render TODO
        }
    }

    _showLoadingIndicator() {
        // this._loadingIndicator.showLoader();
    }

    _hideLoadingIndicator() {
        // this._loadingIndicator.complete();
        //relayout isotopes after images are loaded. 
        this._renderTarget.find('#isotope-grid-target').imagesLoaded( function() {
            // init Isotope
            this._renderTarget.find('#isotope-grid-target').isotope({
              
            });
          }.bind(this));
    }
    _fallbackCopyTextToClipboard(str){
        let el = document.createElement('textarea');
        el.value = str;
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
    }
    _copyToClipboard(text) {
        if (!navigator.clipboard) {
            this._fallbackCopyTextToClipboard(text);
            return;
        }
        navigator.clipboard.writeText(text);
    }

    _handleCopyShare(e) {
        e.preventDefault();
        this._copyToClipboard(window.location.href);
    }
    _handleLinkedInShare(e) {
        e.preventDefault();
        let share_link = encodeURIComponent(window.location.href);
        share_link = "https://www.linkedin.com/sharing/share-offsite/?url="+share_link;
        
        let windowFeatures = "left=100,top=100,width=500,height=800,popup=true";
        let handle = window.open(
        share_link,
        "shareLIWindow",
        windowFeatures,
        );
        if (!handle) {
        // The window wasn't allowed to open
        // This is likely caused by built-in popup blockers.
        // …
            //what to do? TODO 
        }

        
        
    }
    _handleFacebookShare(e) {
        e.preventDefault();
        let share_link = encodeURIComponent(window.location.href);
        share_link = "https://www.facebook.com/sharer/sharer.php?u="+share_link;
        
        let windowFeatures = "left=100,top=100,width=500,height=800,popup=true";
        let handle = window.open(
        share_link,
        "shareFBWindow",
        windowFeatures,
        );
        if (!handle) {
        // The window wasn't allowed to open
        // This is likely caused by built-in popup blockers.
        // …
            //what to do? TODO 
        }

    }
    // Email Share? 
    _handleEmailShare(e) {
        e.preventDefault();
        this._copyToClipboard(window.location.href);
    }

    //#endregion

    //#region State Management

    _currentlySelectedVideo = null;
    _currentlySelectedTags = [];
    _watchUriPart = '/v/';
    
    set _currentVideo(value) {
        if(value == null && this._currentlySelectedVideo != null) {
            this._currentlySelectedVideo = null;
            this.dispatchEvent(StandAloneVideoWidgetPage.EVENT_URL_DATA_CHANGED);
        } else if(this._currentlySelectedVideo == null || this._currentlySelectedVideo.id != value.id) {
            this._currentlySelectedVideo = value;
            this.dispatchEvent(StandAloneVideoWidgetPage.EVENT_URL_DATA_CHANGED);
        }
    }
    
    set _currentTags(value) {
        this._currentlySelectedTags = value;
        this.dispatchEvent(StandAloneVideoWidgetPage.EVENT_URL_DATA_CHANGED);
    }

    _getCurrentUrl() {
        let url = 'https://' + window.location.host;
        if(this._currentlySelectedVideo != null) {
            url += this._watchUriPart + this._currentlySelectedVideo.id + '/';
        }
        return url;
    }
    
    _appendQueryArgsToUrl(url, args) {
        if(Object.keys(args).length > 0) {
            var params = Object.keys(args).map(function(key) { 
                return key + '=' + encodeURIComponent(args[key]);
            }).join('&'); 
            let join = '?';
            if(url.indexOf('?') != -1) {
                join = '&';
            }
            url += join + params;
        }
        return url;
    }

    _encodeUrlFromCurrentState() {
        // Should get https://domain.com/feed/widgetCode
        let url = this._getCurrentUrl();
        let args = {};
        if(this._currentlySelectedTags.length > 0) {
            let _tagNames = [];
            for(var i = 0;i < this._currentlySelectedTags.length;i++) {
                _tagNames.push(this._currentlySelectedTags[i].tag_name);
            }
            args['tags'] = _tagNames.join(',');
        }
        url = this._appendQueryArgsToUrl(url, args);
        return url;
    }

    
    _getVideoIdFromUrl() {
        if(window.location.pathname.indexOf(this._watchUriPart) != -1) {
            let _start = window.location.pathname.indexOf(this._watchUriPart) + this._watchUriPart.length;
            return window.location.pathname.substring(
                _start,
                window.location.pathname.indexOf('/', _start + 1)
            );
        }
        return null;
    }

    _decodeUrlForCurrentState() {
        let urlParams = new URLSearchParams(window.location.search);
        let videoId = this._getVideoIdFromUrl();
        let tagNames = urlParams.get('tags');
        if(videoId != null) {
            // triggering the modal click interferes with the isotope grid (likely because it prevents body resizing)
            // we'll handle the video select logic after isotope is done
            this._currentlySelectedVideo = this._videoWidget.getVideoById(videoId);
            if(tagNames != null) {
                this._isotopeGrid.one('arrangeComplete', this._handleSnapToCurrentVideo.bind(this));
            }
        }
        if(tagNames != null) {
            // iterate, find by name (better than throwing UUIDs in the URI), update props
            let _tags = [];
            let eachTagNames = tagNames.split(',');
            if(eachTagNames.length > 0) {
                for(var i = 0;i < eachTagNames.length;i++) {
                    let _tag = this._videoWidget.getTagByTagName(eachTagNames[i]);
                    if(_tag != null) {
                        _tags.push(_tag);
                    }
                }
            }

            if(_tags.length > 0) {
                this._currentlySelectedTags = _tags;
                for(var i = 0;i < _tags.length;i++) {
                    let $input = this._renderTarget.find('.tag-input[value="' + _tags[i].uuid + '"]');
                    let $tag = $input.closest('.tag');
                    $input.prop('checked', true);
                    if($tag.hasClass('toggleable') == true && $tag.hasClass('active') == false) {
                        $input.closest('.tag-type-card').find('.show-more').trigger('click');
                    }
                }
                this._isotopeFilter();
            }
        } else if(videoId != null) {
            this._handleSnapToCurrentVideo();
        } else {
            this.dispatchEvent(StandAloneVideoWidgetPage.EVENT_READY);
        }
        // this will clean the URI if any false tags/video id was added, going to just call directly rather than use an event
        this._handleHistoryState();
    }

    _handleHistoryState() {
        window.history.replaceState(null, 'VideoMyJob', this._encodeUrlFromCurrentState());
    }

    _handleSnapToCurrentVideo() {
        if(this._currentlySelectedVideo != null) {
            let _videoElement = this._renderTarget.find('.video-modal-link[data-id="'  + this._currentlySelectedVideo.id + '"]');
            _videoElement[0].scrollIntoView({block: "center"});
            _videoElement.trigger('click');
        }
        this.dispatchEvent(StandAloneVideoWidgetPage.EVENT_READY);
    }

    //#endregion

    //#region General Event Handlers

    _handleVideoItemClicked(e) {
        e.preventDefault();
        this._videoOpenCount++;
        this._analytics.track({
            name: 'Click',
            value: 'Video Modal Clicked'
        });
        let currentId = $(e.currentTarget).data('id');
        let currentVideo = this._videoWidget.getVideoById(currentId);
        if(currentVideo != null) {
            this._player.playlist.currentItem(this._player.playlist.indexOf(currentVideo.video_streams[0].src));
            this._videoModal.modal('show');
            this._currentVideo = currentVideo;
        }
    }

    _handleCTAClicked(e) {
        let video = this._videoWidget.videos[this._player.playlist.currentItem()];
        if($(e.currentTarget).hasClass('fallback')) {
            this._analytics.track({
                name: 'Click',
                value: 'Widget Video CTA Clicked',
                video_id: video.id
            });
        } else {
            this._analytics.track({
                name: 'Click',
                value: 'cta_bottom_hero_override_clicked',
                video_id: video.id
            });
        }
    }

    _handleNextClicked(e) {
        e.preventDefault();
        this._player.playlist.currentItem($(e.currentTarget).data('playlist-id'));
        this._removeOverlay();
        this._player.play();
        this._analytics.track({
            name: 'Click',
            value: 'Video_Playlist_Click'
        });
    }

    _handleWatchAgainClicked(e) {
        e.preventDefault();
        this._player.currentTime(0);
        this._player.play();
        this._removeOverlay();
        this._analytics.track({
            name: 'Click',
            value: 'Video_Watch_Again_Click'
        });
    }

    _handleAutoPlayCancelled(e) {
        e.preventDefault();
        this._stopAutoAdvance();
        this._analytics.track({
            name: 'Click',
            value: 'Video_Playlist_Cancel_Click'
        });
    }

    _handleClearFiltersClicked(e) {
        e.preventDefault();
        this._renderTarget.find(".tag input:checked").each(function(i, e) {
            $(e).prop("checked", false);
        })
        this._isotopeGrid.isotope({filter: '*'});

    }

    async _handleFilterInputChanged(e) {
        let _task = this._updateCurrentlySelectedTags();

        // if we're in the mobile version, we'll toggle the normal sidebar on, and the reverse is also true
        let currentVal = $(e.currentTarget).val();
        if($(e.currentTarget).closest('.filter-sidebar-container').length > 0) {
            this._renderTarget.find('.filter-column .tag [value="' + currentVal + '"]').prop('checked', $(e.currentTarget).prop('checked'));
        } else {
            this._renderTarget.find('.filter-sidebar-container .tag [value="' + currentVal + '"]').prop('checked', $(e.currentTarget).prop('checked'));
        }
        
        this._isotopeFilter();
        this._analytics.track({
            name: 'Click',
            value: 'filter_click',
            filter_id: currentVal
        });
        await _task;
    }

    _isotopeFilter() {
        var filters = [];
        this._renderTarget.find('.filter-column .tag input').each(function(i, e) {
            if($(e).is(':checked')) {
                filters.push(".tag-" + $(e).val());
            }
        });

        this._isotopeGrid.isotope({filter:filters.join(',')});

    }

    async _updateCurrentlySelectedTags() {
        let newTags = [];
        this._renderTarget.find('.filter-column .tag input').each((function(i, e) {
            if($(e).is(':checked')) {
                let _tag = this._videoWidget.getTagById($(e).val(), $(e).data('tagtypeuuid'));
                if(_tag != null) {
                    newTags.push(_tag);
                }
            }
        }).bind(this));
        this._currentTags = newTags;
    }

    _handleOpenSidebarClicked(e) {
        e.preventDefault();
        this._renderTarget.find('#mySidebar').css('left', '0%');
        this._renderTarget.find('.sidebar-container').addClass('active');
    }

    _handleCloseSidebarClicked(e) {
        e.preventDefault();
        this._renderTarget.find('#mySidebar').css('left', '-100%');
        this._renderTarget.find('.sidebar-container').removeClass('active');
    }

    _handleShowMoreTagsClicked(e) {
        e.preventDefault();
        let $toggleable = $(e.currentTarget).closest('.tag-type-card').find('.tag.toggleable');
        $toggleable.toggleClass('active');
        if ($toggleable.hasClass("active")) {
                $(e.currentTarget).find("span").text("Show Less");
        } else {
            $(e.currentTarget).find("span").text("Show More");
        }
    }

    _handleMouseEnterVideoItemCard(e) {
        if($(e.currentTarget).data('gifsrc')) {
            $(e.currentTarget).attr('src', $(e.currentTarget).data('gifsrc'));
        }
    }

    _handleMouseLeaveVideoItemCard(e) {
        $(e.currentTarget).attr("src", $(e.currentTarget).data("thumbnailsrc"));
    }

    _handleHeroButtonClicked(e) {
        this._analytics.track({
            name: 'Click',
            value: 'hero_button_clicked'
        });
    }

    //#endregion

    //#region Video Player

    _player = null;
    _isIdle = true;
    _overlayTimerInterval = null;
    _timeElapsed = 1;
    _overlayTimer = 0;

    get videoPlayerConfig() {
        return {
            preload: 'metadata',
            autoplay: false,
            controls: true,
            controlBar: {
                fullscreenToggle: false
            },
            aspectRatio: "16:9",
            bigPlayButton: false,
            html5: {
                vhs: {
                    overrideNative: true,
                    useBandwidthFromLocalStorage: true,
                    limitRenditionByPlayerDimensions: false,
                    useDevicePixelRatio: true,
                    smoothQualityChange: true
                },
                nativeAudioTracks: false,
                nativeVideoTracks: false
            },
            error: function() {
                console.log('error');
            }
        };
    }

    _initPlayer() {
        this._player = videojs('modal-player', this.videoPlayerConfig);
        //set up the event tracking extension 
        this._player.eventTracking({});
        //set the analytics player 
        this._analytics.setPlayer(this._player);
        // used by the next/prev playlist buttons
        let button = videojs.getComponent('Button');
        let player = this._player;
        //#region Next Playlist Item
        // NOTE: videojs.extend is NOT supported in vjs8+
        let nextPlaylistItem = new (videojs.extend(button, {
            constructor: function() {
                button.call(this, player);
                this.addClass('vjs-icon-next-item');
                this.controlText('Next')
            },

            handleClick: function() {
                player.playlist.next();
                this._analytics.track({
                    name: 'Click',
                    value: 'Video_Timeline_Next_Click'
                });
            }
        }));
        this._player.controlBar.addChild(nextPlaylistItem, {}, 2);
        //#endregion
        //#region Prev Playlist Item
        let prevPlaylistItem = new (videojs.extend(button, {
            constructor: function() {
                button.call(this, player);
                this.addClass('vjs-icon-previous-item');
                this.controlText('Previous')
            },

            handleClick: function() {
                player.playlist.previous();
                this._analytics.track({
                    name: 'Click',
                    value: 'Video_Timeline_Previous_Click'
                });
            }
        }));
        this._player.controlBar.addChild(prevPlaylistItem, {}, 2);
        //#endregion


        // data to playlist structure 
        this._player.playlist(this._videoWidget.getVideoList(),-1);
        //this is the delay between playlist items 
        this._player.playlist.autoadvance(0);
        //this allows the last video to auto advance to the first 
        this._player.playlist.repeat(true);
        this._player.on('playlistitem', this._handlePlayListItem.bind(this));
        this._player.on('ended', this._handleEnded.bind(this));
        this._videoModal.on('hidden.bs.modal', this._handleVideoPlayerModalHidden.bind(this));
    }

    _removeOverlay() {
        this._videoModal.find('.video-overlay').remove();
    }

    _renderOverlay(video, nextVideos) {
        this._removeOverlay();
        this._videoModal.find('.video-container').append(videoPlayerOverlayTemplate({
            next_videos:nextVideos,
            video:video,
            countdown:0
        }));
    }

    _showOverlay() {
        this._videoModal.find('.video-overlay').addClass('visible');
    }

    _handlePlayListItem() {
        this._removeOverlay();

        let currentIndex = this._player.playlist.currentItem();
        let videoData = this._player.playlist()[currentIndex];
        // reset video content
        let $videoInfoContainer = this._videoModal.find('.video-info-container');
        $videoInfoContainer.html('');
        if(typeof(videoData) != 'undefined' && videoData != null && videoData.hasOwnProperty('video_id')) {
            let currentVideo = this._videoWidget.getVideoById(videoData.video_id);
            if(currentVideo != null) {
                this._currentVideo = currentVideo;
                this._analytics.setVideoId(currentVideo.id);
                $videoInfoContainer.html(videoInfoContainerTemplate(currentVideo));

                let nextVideos = [];
                for(let i = 1; i <= 3;i++) {
                    let playlistItem = this._player.playlist()[(currentIndex + i) % this._player.playlist().length];
                    if(playlistItem.id == currentVideo.id) {
                        break;
                    }
                    nextVideos.push(playlistItem);
                }
                this._renderOverlay(currentVideo, nextVideos);
            }
        }
    }

    _handleEnded() {
        if(this._player.isFullscreen()) {
            this._player.exitFullscreen();
        }

        this._showOverlay();
        if(this._isIdle) {
            setTimeout(this._stopAutoAdvance.bind(this), 500);
        } else {
            this._clearOverlayTimer();
        }
        this._currentVideo = null;
    }

    _handleIsIdleCallback() {
        this._isIdle = true;
    }

    _handleVideoPlayerModalHidden() {
        if(this._videoOpenCount == 3){
            this.showFeedbackModal();
        }
        this._currentVideo = null;
        this._player.pause();
        this._analytics.track({
            name: 'Click',
            value: 'Iframe modal closed'
        });
    }

    _stopAutoAdvance() {
        this._player.playlist.autoadvance(-1);
        this._clearOverlayTimer();
    }

    _clearOverlayTimer() {
        if(this._overlayTimerInterval != null) {
            clearInterval(this._overlayTimerInterval);
        }
    }

    _createOverlayTimer() {
        this._clearOverlayTimer();
        this._overlayTimer = 0;
        this._timeElapsed = 1;
        this._overlayTimerInterval = setInterval(
            this._overlayIntervalHandler.bind(this),
            1000
        );
    }

    _overlayIntervalHandler() {
        this._videoModal.find('.video-overlay .countdown').html(this._overlayTimer - this._timeElapsed);
        this._timeElapsed++;
        if(this._timeElapsed >= this._overlayTimer || this._isIdle) {
            this._clearOverlayTimer();
            this._analytics.track({
                name: 'Click',
                value: 'Video_Auto_Next'
            });
        }
    }

    //#endregion

    //#region Feedback Modal

    _feedbackClosed = false;
    _feedbackResponse = null;

    showFeedbackModal() {
        this._feedbackModal.modal('show');
        this._analytics.track({
            name: 'Click',
            value: 'Feedback Prompt Shown'
        });
    }

    _handleFeedbackModalHidden(e) {
        this._feedbackClosed = true;
        if(this._feedbackResponse == 'No') {
            this._analytics.track({
                name: 'Click',
                value: 'No Feedback Close'
            });
        } else if(this._feedbackResponse == 'Yes') {
            this._analytics.track({
                name: 'Click',
                value: 'Yes Feedback Close'
            });
        } else {
            this._analytics.track({
                name: 'Click',
                value: 'Feedback Skip/Close'
            });
        }

    }

    _handleFeedbackResponseClicked(e) {
        this._feedbackResponse = $(e.currentTarget).data('feedback');

        this._feedbackModal.find(".satisfied-feedback").addClass("hide");
        this._feedbackModal.find(".feedback-form-container").removeClass("hide");
        this._feedbackModal.find(".feedback-form-container").addClass("show");

        if(this._feedbackResponse == "No") {
            this._analytics.track({
                name: 'Click',
                value: 'Feedback No'
            });
            this._analytics.track({
                name: 'Click',
                value: 'No Feedback Input Shown'
            });
            

        } else {
            this._analytics.track({
                name: 'Click',
                value: 'Feedback Yes'
            });
            this._analytics.track({
                name: 'Click',
                value: 'Yes Feedback Input Shown'
            });
        }
    }

    _handleFeedbackUserDescriptionClicked(e) {
        this._canSubmitFeedback();
        if($(e.currentTarget).attr('id') == 'other') {
            this._feedbackModal.find('#other-user').removeClass('hide');
        } else {
            this._feedbackModal.find('#other-user').addClass('hide');
        }
    }

    _handleFeedbackTextKeyUp(e) {
        this._canSubmitFeedback();
    }

    _canSubmitFeedback() {
        let $checkedElement = this._feedbackModal.find(".feedback-form input[name='user_description']:checked");
        let $feedback = this._feedbackModal.find(".feedback-form #feedback");
        let $otherUser = this._feedbackModal.find(".feedback-form #other-user");
        let $submitButton = this._feedbackModal.find("#submit-feedback");
        $submitButton.attr('disabled', 'disabled');
        if($feedback.val().trim().length <= 0 || $checkedElement.length <= 0) {
            return false;
        } else if($checkedElement.attr('id') == 'other' && $otherUser.val().trim().length <= 0) {
            return false;
        }
        $submitButton.removeAttr('disabled');
        return true;
    }

    _handleFeedbackSubmit(e) {

        if(this._feedbackResponse == "No") {
            this._analytics.track({
                name: 'Click',
                value: 'Feedback No'
            });
        } else if(this._feedbackResponse == 'Yes') {
            this._analytics.track({
                name: 'Click',
                value: 'Feedback Yes'
            });
        }
    }

    //#endregion
}